import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

// Import your pages here
import MyVisaScreen from "./pages/myVisaScreen";
import UnsubscribeScreen from "./pages/unsubscribeScreen";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/visas" element={<MyVisaScreen />} />
          <Route path="/visas/unsubscribe" element={<UnsubscribeScreen />} />
          <Route path="*" element={<Navigate to="/visas" replace />} />
        </Routes>
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
